import React from 'react'
import "./complianceList.scss"


import SectionComponent from '../../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next'

function ComplianceList() {
  const { t } = useTranslation()

  return (
    <div className='container-compliance-list'>
      <div className="texts-compliance-list">

        <SectionComponent title={t("financial_services.compliance_list.compliance.title")} text={t("financial_services.compliance_list.compliance.section_text_1")} >
          <p>{t("financial_services.compliance_list.compliance.section_text_2")}</p>
          <p>{t("financial_services.compliance_list.compliance.section_text_3")}</p>
          <p>{t("financial_services.compliance_list.compliance.section_text_4")}</p>
        </SectionComponent>

        <SectionComponent title={t("financial_services.compliance_list.fraud.title")} text={t("financial_services.compliance_list.fraud.section_text_1")}>
          <p>{t("financial_services.compliance_list.fraud.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("financial_services.compliance_list.customer_plans.title")} text={t("financial_services.compliance_list.customer_plans.section_text_1")}>
          <p>{t("financial_services.compliance_list.customer_plans.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("financial_services.compliance_list.treasury.title")}  text={t("financial_services.compliance_list.treasury.section_text_1")} >
          <p>{t("financial_services.compliance_list.treasury.section_text_2")}</p>
          <p>{t("financial_services.compliance_list.treasury.section_text_3")}</p>
          <p>{t("financial_services.compliance_list.treasury.section_text_4")}</p>

        </SectionComponent>
      </div>
    </div>
  )
}

export default ComplianceList